import { Button, Heading, Paragraph, Tabs } from "@digdir/designsystemet-react";
import { ArrowRightLeftIcon } from "@navikt/aksel-icons";
import { Link, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { env } from "@/env";
import { useSelskaper } from "@/features/selskap/SelskapContext";
import { GlobaltVarsel } from "@/features/varsler/GlobaltVarsel";
import type { FileRoutesByTo } from "@/routeTree.gen";
import { formatOrgNr } from "@/utils";

type Tab = {
  label: string;
  to: keyof FileRoutesByTo;
  value: string;
  enabled?: boolean;
};
const tabs: Tab[] = [
  {
    label: "pages.bestillinger.tittel",
    to: "/bestillinger" as keyof FileRoutesByTo,
    value: "bestillinger",
  },
  {
    label: "pages.maalerdata-perioder.tittel",
    to: "/maalerdata" as keyof FileRoutesByTo,
    value: "maaledata",
    enabled: env.featureMaaledataEnabled,
  },
];

export const SelskapsHeader = () => {
  const { t } = useTranslation();
  const { active } = useSelskaper();
  const navigate = useNavigate();

  const activeTab =
    tabs.find((tab) => window.location.pathname.includes(tab.to))?.value ||
    "bestillinger";

  const filteredTabs = tabs.filter((t) => t.enabled !== false);

  return (
    <header className="w-full bg-balder-background-tinted border-b border-balder-border-subtle pb-0">
      <GlobaltVarsel />

      <div className="max-w-page px-5 sm:px-15 mx-auto space-y-6 pt-12">
        <div className="flex gap-6 items-center">
          <Heading level={1} data-size="lg" className="algin-middle">
            {`${active?.navn} `} ({formatOrgNr(active?.organisasjonsnummer)})
          </Heading>
          <Button variant="secondary" asChild>
            <Link to="/selskap">
              <ArrowRightLeftIcon
                fontSize={"1.5rem"}
                aria-label={t("selskap-header.bytt-valgt-aktor")}
              />
              <span className="hidden sm:inline-flex">{`${t("selskap-header.bytt-selskap")}`}</span>
            </Link>
          </Button>
        </div>
        <Paragraph
          data-size="md"
          className="text-balder-text-subtle whitespace-pre-line pb-2 max-w-2xl"
        >
          {t("selskap-header.beskrivelse")}
        </Paragraph>

        <Tabs defaultValue={activeTab}>
          <Tabs.List className="border-none">
            {filteredTabs.map((tab) => (
              <Tabs.Tab
                key={tab.value}
                onClick={() => navigate({ to: tab.to })}
                value={tab.value}
              >
                {t(tab.label)}
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs>
      </div>
    </header>
  );
};
